export enum LOCALSTORAGE_ITEMS {
  LANG = 'lang',
  LANGUAGE_PREFERENCE = 'languagePreference',
}
